
export function uniqueId() {
  const idStrLen = 32;
  let idStr = (Math.floor((Math.random() * 25)) + 10).toString(36);
  idStr += '_';
  idStr += (new Date()).getTime().toString(36);
  idStr += '_';
  do {
    idStr += (Math.floor((Math.random() * 35))).toString(36);
  } while (idStr.length < idStrLen);

  return (idStr);
}

const $ = window.$;

export class Sizer {
  constructor($container, $widget, callback) {
    this.$container = $container;
    this.$widget = $widget;
    this.callback = callback;
    this.resizeHandler = this.onWindowResize.bind(this);
    $(window).resize(this.resizeHandler);
    this.adjustSize();
  }

  clear() {
    $(window).off('resize', this.resizeHandler);
  }

  onWindowResize() {
    this.adjustSize();
    setTimeout(this.adjustSize.bind(this), 100);
  }

  adjustSize() {
    const { $container, $widget } = this;
    const width = $container.innerWidth();
    const height = $container.innerHeight();
    if ($widget) {
      $widget.css({ width, height });
    }
    if (this.callback) {
      this.callback(width, height);
    }
  }
}

export function throttle(callback, limit) {
  let wait = false;
  return () => {
    if (!wait) {
      callback();
      wait = true;
      setTimeout(() => { wait = false; }, limit);
    }
  };
}

function pointDist(p1, p2) {
  const x = p2[0] - p1[0];
  const y = p2[1] - p1[1];
  return Math.sqrt((x * x) + (y * y));
}

export function getTimeFromCoords(point, coords) {
  for (let i = 0; i < coords.length - 1; i += 1) {
    const d0 = pointDist(coords[i], coords[i + 1]);
    const d1 = pointDist(point, coords[i]);
    const d2 = pointDist(point, coords[i + 1]);
    if (Math.abs(d0 - d1 - d2) < 0.0001) {
      const t0 = coords[i][2];
      const t1 = coords[i + 1][2];
      const alpha = d1 / d0;
      return t0 + ((t1 - t0) * alpha);
    }
  }
  return undefined;
}

export function getCoordsFromTime(time, coords) {
  if (coords.length === 0) {
    return undefined;
  }
  if (time <= coords[0][2]) {
    return coords[0];
  } else if (time >= coords[coords.length - 1][2]) {
    return coords[coords.length - 1];
  }
  for (let i = 0; i < coords.length - 1; i += 1) {
    const p0 = coords[i];
    const p1 = coords[i + 1];
    const t0 = p0[2];
    const t1 = p1[2];
    if (time >= t0 && time <= t1) {
      const d0 = Math.abs(t1 - t0);
      const d1 = Math.abs(time - t0);
      const alpha = (d0 > 0) ? (d1 / d0) : 0;
      const x = p0[0] + ((p1[0] - p0[0]) * alpha);
      const y = p0[1] + ((p1[1] - p0[1]) * alpha);
      return [x, y, time];
    }
  }
  return undefined;
}

export function getValueFromTime(time, values) {
  if (values.length > 0 && time <= values[0][0]) {
    return values[0];
  }
  for (let i = 0; i < values.length - 1; i += 1) {
    const p0 = values[i];
    const p1 = values[i + 1];
    const t0 = p0[0];
    const t1 = p1[0];
    if (time >= t0 && time <= t1) {
      return p0;
    }
  }
  if (values.length > 0) {
    return values[values.length - 1];
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/utils.js